import React from "react";

interface Props {
  amenitiesData: any;
  amenitiesProps: any
  amenitiesImages: any;
  amenityFilter: string;
  colorsData: any;
  angle: number;
  show: boolean;
  handleAmenitiesBillboardFilter: any;
  links: any
}

interface State {
  angle: number;
  showBillboards: boolean;
  currentRadius: number
  amenitiesObject: any,
  currentIndexSelected: number
}
declare const window: any;

interface amenitiesLayouts {
  billboards: any;
}

class amenitiesLayouts extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      angle: 0,
      showBillboards: false,
      currentRadius: 4,
      amenitiesObject: {},
      currentIndexSelected: -1
    };
  }

  componentDidMount(): void {
    this.billboards = <div></div>;
    var decreasing = false 

    var tempObject: any = {}

    //console.log(this.props.amenitiesProps);
    

    this.props.amenitiesProps.menu.map((data: any) => {
      if(tempObject.hasOwnProperty(data.id) === false){
        //console.log(data.id);
        
        tempObject[data.id] = ""
        //console.log(tempObject);
        
      }

      return null
    })

    setInterval(() => {
      if(this.state.currentRadius + 1 <= 5 && decreasing === false){
        this.setState({
          currentRadius: this.state.currentRadius + 1
        }, () => {
          decreasing = this.state.currentRadius === 5
        })
      }
      if(this.state.currentRadius - 1 >= 2 && decreasing){
        this.setState({
          currentRadius: this.state.currentRadius - 1
        }, () => {
          decreasing = this.state.currentRadius === 2 ? false:true
        })
      }
    },150)

    console.log(this.props.amenitiesData);
    

    var sortedAmenities: any = this.props.amenitiesData.amenities_coord_file[40].amenities
    sortedAmenities.sort((a: any,b: any) => a.verts[0] - b.verts[0])

    sortedAmenities.map((data: any, index: number) => {
      tempObject[data.id] = index + 1
      return null
    })

    var counter = sortedAmenities.length

    Object.keys(tempObject).map((key: any) => {
      if(tempObject[key] === ''){
        tempObject[key] = counter
        counter++
      }

      return null
    })

    this.setState({
      showBillboards: true,
      amenitiesObject: tempObject
    });


  }

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    if (
      this.props.amenitiesData !== prevProps.amenitiesData &&
      this.props.amenitiesData.amenities_coord_file
    ) {
      this.setState({
        showBillboards: true,
      });

    }
    /*if (this.props.angle !== prevProps.angle) {
      this.createBillboards();
    }*/
    if (this.props.amenityFilter !== prevProps.amenityFilter) {
      this.createBillboards();
    }
    if(prevProps.links !== this.props.links){
      this.createBillboards();
    }
  }

  createBillboards = () => {
    if (
      this.props.amenitiesData.amenities_coord_file &&
      this.props.amenitiesData.amenities_coord_file[this.props.angle]
    ) {
      if (
        this.props.amenitiesData.amenities_coord_file[this.props.angle]
          .amenities.length > 0
      ) {
        if (this.props.amenityFilter) {
          return this.props.amenitiesData.amenities_coord_file[
            this.props.links.length === 50 ?
            this.props.angle * 2 :
            this.props.angle
          ].amenities.map((amenity: any, index: number) =>
            this.props.amenityFilter === amenity.id ? (
              <React.Fragment>
                <line 
                  x1={amenity.verts[0]} 
                  y1={amenity.verts[1] - (this.state.amenitiesObject[amenity.id] % 3 === 0 ? 170: this.state.amenitiesObject[amenity.id] % 2 === 0 ? 115:40)} 
                  x2={amenity.verts[0]} 
                  y2={amenity.verts[1]} 
                  stroke="#fff" 
                  stroke-width="2" 
                />
                <circle
                cx={amenity.verts[0]}
                cy={amenity.verts[1]}
                r={this.state.currentRadius}
                style={{
                  cursor: this.props.show ? "pointer" : "none",
                  fill: "rgba(255,255,255,.85)",
                  stroke: "rgba(255,255,255,.85)",
                  strokeWidth: 1,
                }}
              />
                <circle
                  cx={amenity.verts[0]}
                  cy={amenity.verts[1] - (this.state.amenitiesObject[amenity.id] % 3 === 0 ? 170: this.state.amenitiesObject[amenity.id] % 2 === 0 ? 115:40)}
                  r={"30"}
                  style={{
                    cursor: this.props.show ? "pointer" : "none",
                    fill: "rgba(255,255,255,.85)",
                    stroke: "rgba(255,255,255,.85)",
                    strokeWidth: 1,
                  }}
                  onClick={() => {
                    this.props.handleAmenitiesBillboardFilter(amenity.id);
                  }}
                />
                {this.props.amenitiesImages.menu.map(
                  (amenitiesImages: any, indexAmenities: number) =>
                    amenitiesImages.id === amenity.id ? (
                      <image
                        key={amenitiesImages.icon + indexAmenities}
                        href={
                          (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                          amenitiesImages.icon
                        }
                        width="30"
                        height="30"
                        x={amenity.verts[0] - 15 }
                        y={amenity.verts[1] - 15 - (this.state.amenitiesObject[amenity.id] % 3 === 0 ? 170: this.state.amenitiesObject[amenity.id] % 2 === 0 ? 115:40)}
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          this.props.handleAmenitiesBillboardFilter(amenity.id);
                        }}
                      ></image>
                    ) : null
                )}
              </React.Fragment>
            ) : null
          );
        } else {
          return this.props.amenitiesData.amenities_coord_file[
            this.props.links.length === 50 ?
            this.props.angle * 2:
            this.props.angle
          ].amenities.map((amenity: any, index: number) => (
            <React.Fragment>
              <line x1={amenity.verts[0]} y1={amenity.verts[1] - (this.state.amenitiesObject[amenity.id] % 3 === 0 ? 170: this.state.amenitiesObject[amenity.id] % 2 === 0 ? 115:40)} x2={amenity.verts[0]} y2={amenity.verts[1]} stroke="#fff" stroke-width="2" /*stroke-dasharray="5,5"*/ />
              <circle
                cx={amenity.verts[0]}
                cy={amenity.verts[1]}
                r={this.state.currentRadius}
                style={{
                  cursor: this.props.show ? "pointer" : "none",
                  fill: "rgba(255,255,255,.85)",
                  stroke: "rgba(255,255,255,.85)",
                  strokeWidth: 1,
                }}
                onClick={() => {
                  this.props.handleAmenitiesBillboardFilter(amenity.id);
                }}
              />
              <circle
                cx={amenity.verts[0]}
                cy={amenity.verts[1] - (this.state.amenitiesObject[amenity.id] % 3 === 0 ? 170: this.state.amenitiesObject[amenity.id] % 2 === 0 ? 115:40)}
                r={this.state.currentIndexSelected === index ? "25":"20"}
                style={{
                  cursor: this.props.show ? "pointer" : "none",
                  fill: "rgba(255,255,255,.85)",
                  stroke: "rgba(255,255,255,.85)",
                  strokeWidth: 1,
                  zIndex: 2
                }}
                onClick={() => {
                  this.props.handleAmenitiesBillboardFilter(amenity.id);
                }}
                onMouseEnter={() => {
                  this.setState({
                    currentIndexSelected: index
                  })
                }}
                onMouseLeave={() => {
                  this.setState({
                    currentIndexSelected: -1
                  })
                }}
              />
              {this.props.amenitiesImages.menu.map(
                (amenitiesImages: any, indexAmenities: number) =>
                  amenitiesImages.id === amenity.id ? (
                    <image
                      key={amenitiesImages.icon + indexAmenities}
                      href={
                        (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                        amenitiesImages.icon
                      }
                      width={this.state.currentIndexSelected  === index ? "25":"20"}
                      height={this.state.currentIndexSelected  === index ? "25":"20"}
                      x={amenity.verts[0] - (this.state.currentIndexSelected  === index ? 12.5:10)}
                      y={amenity.verts[1] - (this.state.currentIndexSelected  === index ? 12.5:10) - (this.state.amenitiesObject[amenity.id] % 3 === 0 ? 170: this.state.amenitiesObject[amenity.id] % 2 === 0 ? 115:40)}
                      style={{
                        cursor: "pointer",
                        zIndex: 2
                      }}
                      onClick={() => {
                        this.props.handleAmenitiesBillboardFilter(amenity.id);
                      }}
                      onMouseEnter={() => {
                          this.setState({
                            currentIndexSelected: index
                          })
                        }}
                        onMouseLeave={() => {
                          this.setState({
                            currentIndexSelected: -1
                          })
                        }}
                    ></image>
                  ) : null
              )}
            </React.Fragment>
          ));
        }
      }
    }
  };

  render(): React.ReactNode {
    return (
      <div
        className={
          this.props.show
            ? "amenities-billboards-component fade-in"
            : "amenities-billboards-component fade-out"
        }
      >
        {this.state.showBillboards ? (
          <svg
            width={"100%"}
            height={"100%"}
            preserveAspectRatio="xMidYMid slice"
            viewBox="0 0 2000 1400"
            style={{
              overflow: "hidden",
              pointerEvents: "none",
              position: "absolute",
            }}
          >
            <g
              style={{
                pointerEvents: this.props.show ? "visibleFill" : "none",
              }}
            >
              {this.createBillboards()}
            </g>
          </svg>
        ) : null}
      </div>
    );
  }
}

export default amenitiesLayouts;
